import { GET_TOKENCA_FAILED, GET_TOKENCA_SUCCESS } from 'redux/actions';
import { IAction, ITokenCAResponse } from 'interfaces/common';

export function GetTokenCA(
  state: ITokenCAResponse[] = [],
  action: IAction<ITokenCAResponse[]>
) {
  switch (action.type) {
    case GET_TOKENCA_SUCCESS:
      return action.payload;
    case GET_TOKENCA_FAILED:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/global-reducers/GetTokenCA.ts